// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__2bsOF","row":"styles_row__1msBk"};